import { faWindowClose, faSearch } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { Input, InputGroup, InputGroupAddon } from "reactstrap";
import { defaultLanguage } from "../../helper/utility";
import { language } from "../../languageProvider/language/language";
import OutsideAlerter from "./OutsideClick";
import SearchResults from "./SearchResults";
import LoaderModal from "../common/LoaderModal";
import { serverResponse } from "../../util/fakeServer";

const MAX_HEIGHT_RESULT_CONTAINER = 300;
const ITEM_HEIGTH = 55;

const Searchbar = (props) => {
  const hideOrShowSearchResults = (display) => {
    if (display === "none") {
      props.setDisplaySearchResults(display);
    } else {
      props.setDisplaySearchResults(display);
    }
  };

  const groupBy = (arr, prop) => {
    var grouped = {};
    for (var i = 0; i < arr.length; i++) {
      var p = arr[i][prop];
      if (!grouped[p]) {
        grouped[p] = [];
      }
      grouped[p].push(arr[i]);
    }

    return grouped;
  };

  const controlledSearch = () => {
    const isEmptyString = props.searchText.replace(/ /g, "") === "";
    const isEqualToLastSeach = props.lastSearch === props.searchText;
    if (!isEmptyString && !isEqualToLastSeach) {
      props.handleSearch2();
    }
  };

  return (
    <>
      <OutsideAlerter
        searchText={props.searchText}
        hideOrShowSearchResults={hideOrShowSearchResults}
        className={
          props.mobileSearch
            ? "d-lg-none d-flex align-items-center w-100 position-relative custom-search-li mobile-search-li"
            : undefined
        }
      >
        <InputGroup style={{ position: "relative" }}>
          <Input
            type="text"
            name="search"
            id="search"
            placeholder={language[defaultLanguage].cerca_un_prodotto}
            value={props.searchText}
            onChange={props.handleSearchTextChange}
            onKeyUp={(e) => {
              if (e.keyCode === 13) controlledSearch();
            }}
          />

          {props.searchText.length > 0 && (
            <div
              style={{
                position: "absolute",
                right: "50px",
                zIndex: 3,
                top: "15%"
              }}
            >
              <FontAwesomeIcon
                onClick={props.resetSearchBar}
                icon={faWindowClose}
              />
            </div>
          )}
          <InputGroupAddon addonType="append">
            <button
              // className="btn"
              onClick={controlledSearch}
              className="input-group-text btn"
              style={{ height: "38px" }}
            >
              <FontAwesomeIcon icon={faSearch} />
            </button>
          </InputGroupAddon>
        </InputGroup>

        <div
          className="container-searchBar shadow"
          style={{
            width: props.mobileSearch ? "100%" : "60%",
            height: `${
              props.loading || props.error
                ? 100
                : props.lastSearch !== ""
                ? props.listFiltered.length * ITEM_HEIGTH + 100
                : 0
            }px`,
            top: "50px",
            display: props.displaySearchResults,
            flexDirection: "column",
            alignItems: "center",
            backgroundColor: "white",
            position: "absolute",
            zIndex: "1",
            maxHeight: `${MAX_HEIGHT_RESULT_CONTAINER}px`
          }}
        >
          {props.loading ? (
            <LoaderModal width="1vw" height="1vh" />
          ) : !props.error ? (
            props.lastSearch && (
              <>
                <p style={{ paddingLeft: "15px" }}>
                  <strong>{`${props.listFiltered.length}`} </strong>
                  {props.listFiltered.length > 1
                    ? "Risultati Trovati"
                    : "Risultato trovato"}{" "}
                  per <strong>{props.lastSearch}</strong>
                  {/* {props.listFiltered.length === 0 && (
                <button  className="btn btn-primary ml-3">
                  Cerca in altri cataloghi
                </button>
              )} */}
                </p>
                {props.listFiltered.length > 0 && (
                  <div
                    style={{
                      width: "100%",
                      overflowY:
                        props.listFiltered.length * ITEM_HEIGTH + 100 >=
                        MAX_HEIGHT_RESULT_CONTAINER
                          ? "scroll"
                          : "hidden"
                    }}
                  >
                    <p
                      style={{
                        position: "sticky",
                        top: 0,
                        backgroundColor: serverResponse.config.primary_color,
                        zIndex: 6,
                        fontWeight: "bold",
                        height: "40px",
                        display: "flex",
                        alignItems: "center"
                      }}
                      className="pl-2 w-100"
                    >
                      Risultati in questo catalogo (
                      {"true" in groupBy(props.listFiltered, "isCurrent")
                        ? groupBy(props.listFiltered, "isCurrent")["true"]
                            .length
                        : 0}
                      )
                    </p>

                    {"true" in groupBy(props.listFiltered, "isCurrent")
                      ? groupBy(props.listFiltered, "isCurrent")["true"].map(
                          (el, index) => {
                            return (
                              <SearchResults
                                isCurrent={true}
                                itemHeigth={ITEM_HEIGTH}
                                key={`${index}_${el.skul}`}
                                element={el}
                                setDisplaySearchResults={
                                  props.setDisplaySearchResults
                                }
                                displaySearchResults={
                                  props.displaySearchResults
                                }
                              />
                            );
                          }
                        )
                      : null}
                    <p
                      style={{
                        position: "sticky",
                        top: 40,
                        backgroundColor: serverResponse.config.primary_color,
                        zIndex: 6,
                        fontWeight: "bold",
                        height: "40px",
                        display: "flex",
                        alignItems: "center"
                      }}
                      className="pl-2 w-100"
                    >
                      Risultati in altri cataloghi (
                      {"false" in groupBy(props.listFiltered, "isCurrent")
                        ? groupBy(props.listFiltered, "isCurrent")["false"]
                            .length
                        : 0}
                      )
                    </p>
                    {"false" in groupBy(props.listFiltered, "isCurrent")
                      ? groupBy(props.listFiltered, "isCurrent")["false"].map(
                          (el, index) => {
                            return (
                              <SearchResults
                                isCurrent={false}
                                itemHeigth={ITEM_HEIGTH}
                                key={`${index}_${el.skul}`}
                                element={el}
                              />
                            );
                          }
                        )
                      : null}
                  </div>
                )}
              </>
            )
          ) : (
            <h6 className="mt-3">
              Si è verificato un errore, ti preghiamo di riprovare
            </h6>
          )}
        </div>
      </OutsideAlerter>
    </>
  );
};

export default Searchbar;
